/**
 * @generated SignedSource<<cfe266402a0e898089a155bd5ba7685c>>
 * @relayHash a6bf76d67b2d5f2f04c0fb717eb4852e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4955e9649932b1f87bb0c5a6cbd1c09263e51f14171d1b01f82e5a58964c4f3d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type labelResolverQuery$variables = {
  searchTerm: string;
};
export type labelResolverQuery$data = {
  readonly labelSearch: {
    readonly otherLabels: ReadonlyArray<{
      readonly label: string | null | undefined;
    } | null | undefined>;
    readonly suggestedLabels: ReadonlyArray<{
      readonly label: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type labelResolverQuery = {
  response: labelResolverQuery$data;
  variables: labelResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 25
  },
  {
    "kind": "Variable",
    "name": "searchText",
    "variableName": "searchTerm"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "label"
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "name": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "labelResolverQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "LabelSearchResults",
        "kind": "LinkedField",
        "name": "labelSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "otherLabels",
            "plural": true,
            "selections": (v3/*: any*/)
          },
          {
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "suggestedLabels",
            "plural": true,
            "selections": (v3/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "labelResolverQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "LabelSearchResults",
        "kind": "LinkedField",
        "name": "labelSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "otherLabels",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "suggestedLabels",
            "plural": true,
            "selections": (v4/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a6bf76d67b2d5f2f04c0fb717eb4852e",
    "id": "4955e9649932b1f87bb0c5a6cbd1c09263e51f14171d1b01f82e5a58964c4f3d",
    "metadata": {},
    "name": "labelResolverQuery",
    "operationKind": "query",
    "text": "query labelResolverQuery($searchTerm:String!){labelSearch(searchText:$searchTerm,limit:25){otherLabels{label,id},suggestedLabels{label,id}}}"
  }
};
})();

(node as any).hash = "f2ce1bb386f2b1a0933d20064c91e8f2";

export default node;
